import AdminCompanyGroupDialog from './adminCompanyGroupDialog.container';

export default AdminCompanyGroupDialog;
